module.exports = __webpack_public_path__ + "static/media/stars.89b04972.svg";